/**
 * One clipboard helper for app and admin (QA 2026-10-16): a blocked or missing clipboard shows a toast instead of an
 * unhandled promise rejection. Returns whether the copy worked, so callers can show their "Copied" state.
 */
import { toast } from './toast';

export const COPY_FAILED = "Couldn't copy: your browser blocked the clipboard. Select the text and copy it yourself.";

export async function copyText(text: string, opts: { success?: string; description?: string; quiet?: boolean } = {}): Promise<boolean> {
  try {
    if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) throw new Error('no clipboard');
    await navigator.clipboard.writeText(text);
    if (!opts.quiet) toast.success(opts.success ?? 'Copied', opts.description ? { description: opts.description } : undefined);
    return true;
  } catch {
    toast.error(COPY_FAILED);
    return false;
  }
}
